var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.exibirNorma)?_c('norma-widget',{attrs:{"api-url":_vm.apiUrl,"environment":_vm.environment,"embedded":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }